import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Flex } from '@stashinvest/ui';
import { ChatIcon } from 'stash/components/ai/chat/ChatIcon';
import { UniversalOnboardingSteps } from 'stash/apps/onboarding/UniversalOnboardingGraph';
import { EXPERIMENTS, useIsInExperimentVariation } from 'stash/components/experiments';

const MoneyCoach = () => {
    const location = useLocation();
    const graphStep = location.pathname.split("/")[2];
    const isInAiChatVariation = useIsInExperimentVariation(
        EXPERIMENTS.REPLACE_CHAT_BANNER_WITH_ICON,
        true
    );

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore-next-line
    const step = UniversalOnboardingSteps[graphStep];
    const analytics = step?.props?.productEvents?.aiChat;
    const initMessage =  step?.props?.aiChat?.initMessage;

    return (
        isInAiChatVariation && !!analytics ? (
            <Flex alignItems="center" justifyContent="center">
                <Box className="relative w-full gridMedium:max-w-[34rem] z-10">
                    <ChatIcon
                        analytics={analytics}
                        className="!absolute bottom-[6px] right-[6px] gridMedium:bottom-[10px] gridMedium:right-0"
                        focus={analytics?.focus || ''}
                        initMessage={initMessage}
                    />
                </Box>
            </Flex>
        ) : null
    );
};

export default MoneyCoach;
